// Loading indicator based on http://www.vistaprint.com/root/example/uilibrary#preloader

import React from 'react';

interface PreloaderGraphicProps {
  variant?: 'default' | 'large' | 'extra-large';
  centered?: boolean;
}

export default function PreloaderGraphic(props: PreloaderGraphicProps) {
  const { variant = 'default', centered = false } = props;

  return (
    <aside
      className={`
        preloader-graphic
        preloader-graphic-center
        ${variant !== 'default' ? `preloader-graphic-${variant}` : ''}
        ${centered ? 'preloader-graphic-center' : ''}
      `}
      aria-live="polite"
      role="status"
    >
      <span className="preloader-graphic-inner" />
    </aside>
  );
}
